<!--
 * @Author: yinbing.liu
 * @Date: 2023-09-19 15:12:00
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-03-22 15:17:30
 * @FilePath: /fushigi/src/components/Menu/src/BasicMenu.vue
 * @Description:
-->
<script lang="ts" setup>
import { toRefs, computed } from 'vue'
import BasicMenuItem from './components/BasicMenuItem.vue'
import { RoutesDataItem, getSelectLeftMenuPath } from '@/utils/routes'
import { useApparatusStore } from '@/store/apparatus'
interface Props {
  menuData: RoutesDataItem[]
  routeItem: RoutesDataItem
  mode?: 'vertical' | 'inline'
  theme?: 'dark' | 'light '
  collapsed?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  mode: 'inline',
  theme: 'dark',
  collapsed: false,
})
const { routeItem, menuData, mode } = toRefs(props)
const useApparatus = useApparatusStore()
const { apparatusCount } = toRefs(useApparatus)
const openKeys = computed<string[]>(() => {
  return routeItem.value.parentPath!
})
const selectedKeys = computed<string[]>(() => {
  const selectedKey = getSelectLeftMenuPath(routeItem.value)
  return [selectedKey]
})
</script>
<template>
  <a-menu
    :inline-indent="10"
    class="menu-layout"
    :mode="mode"
    :selected-keys="selectedKeys"
    :open-keys="openKeys"
  >
    <basic-menu-item
      v-for="item in menuData"
      :key="item.path"
      :route-item="item"
      :apparatus-count="apparatusCount"
    >
    </basic-menu-item>
  </a-menu>
</template>
<style lang="less" scoped>
.menu-layout {
  padding: 8px;
  &.ant-menu-inline {
    border-radius: 4px;
    border-right: none;
  }
  &:deep(.ant-menu-inline) {
    background: #fff;
  }

  &:deep(.ant-menu-sub .ant-menu-submenu-title) {
    padding-left: 34px !important;
  }

  &:deep(.ant-menu-sub .ant-menu-item-only-child) {
    padding-left: 34px !important;
  }
  &:deep(.ant-menu-sub .ant-menu-inline) {
    .menu-title {
      padding-left: 18px !important;
    }
  }

  &:deep(.ant-menu-item-selected)::after {
    opacity: 0;
  }
}
</style>
